// extracted by mini-css-extract-plugin
export default {"form":"Form-module__form__1mB0M"};